import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ArenaPage from "@/pages/ArenaPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ArenaPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
